import React, { useState, useEffect } from 'react';
import { Empty, Icon, Spin, Tooltip } from 'antd';
import cn from 'classnames';
import InfoCard from '../../common/InfoCard/InfoCard';
import DropdownButton from '../../common/DropdownButton/DropdownButton';
import useCardPagination from '../../../../../hooks/useCardPagination';
import MeterCard from '../MeterCard/MeterCard';
import { CardButton, CardIconButton } from '../../../../../components/Card';
import { ReactComponent as AddDottedIcon } from '../../../../../resource/AddDottedIcon.svg';
import SearchField from '../../../../../components/SearchField/SearchField';
import { getReplacedString } from '../../../../../helpers/getReplacedString';
import styles from './MetersBlock.module.scss';

const filterBySearch = ({ meters, search }) =>
  meters.filter((item) => {
    const value = getReplacedString(search);
    const serialNumber = getReplacedString(item.serialNumber);

    return serialNumber.includes(value);
  });

const MetersBlock = ({
  className,
  meters = [],
  loading,
  cardSize = 4,
  onInfoClick,
  onAddBtnClick,
}) => {
  const [search, setSearch] = useState('');
  const [filteredMeters, setFilteredMeters] = useState(meters);

  const { shownItems, pagination } = useCardPagination(
    filteredMeters,
    cardSize
  );

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    let newMeters = [];

    if (meters.length) {
      newMeters = search.trim()
        ? filterBySearch({ meters, search: search.trim() })
        : meters;
    }

    setFilteredMeters(newMeters);
  }, [meters, search]);

  const renderCardActions =
    typeof onInfoClick === 'function'
      ? ({ meter }) => (
          <Tooltip title="Детальная информация и редактирование">
            <CardIconButton
              renderIcon={() => <Icon type="info-circle" />}
              onClick={() => onInfoClick({ meter })}
            />
          </Tooltip>
        )
      : undefined;

  return (
    <InfoCard
      title="Счетчики"
      action={meters.length > cardSize && pagination}
      className={cn(styles.root, className)}
    >
      <Spin spinning={loading}>
        {!meters.length && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
        {!!meters.length && (
          <>
            {/* <DropdownButton
              trigger={['click']}
              text="Все счетчики"
              menuItems={menu}
            /> */}
            {meters.length > cardSize && (
              <SearchField
                placeholder="Поиск по номеру счетчика"
                value={search}
                onChange={handleSearchChange}
              />
            )}
            <ul className={styles.metersList}>
              {shownItems.map((meter, index) => (
                <li key={index}>
                  <MeterCard meter={meter} renderActions={renderCardActions} />
                </li>
              ))}
            </ul>
          </>
        )}
        {typeof onAddBtnClick === 'function' && (
          <CardButton
            className={styles.cardBtn}
            block
            text="Добавить счетчик"
            icon={<AddDottedIcon />}
            onClick={onAddBtnClick}
          />
        )}
      </Spin>
    </InfoCard>
  );
};

export default MetersBlock;
